import { useState, useEffect } from "react";
import moment from "moment";
import qs from "qs";

const useGoogleCalendar = () => {
  const [events, setEvents] = useState<any>(null); //@TODO fix the typing
  const [loading, setLoading] = useState(true);
  const calendarID = process.env.GOOGLE_CALENDAR_ID;
  const apiKey = process.env.GOOGLE_API_KEY;
  useEffect(() => {
    if (!calendarID || !apiKey) return;

    getEvents(calendarID, apiKey);
  }, []);

  const getEvents = async (calendarID: string, apiKey: string) => {
    const now = moment().toISOString();

    const queryParams = {
      orderBy: "startTime",
      singleEvents: true,
      maxResults: 6,
      timeMin: now,
    };
    const queryStr = qs.stringify(queryParams);

    const response = await fetch(
      `https://www.googleapis.com/calendar/v3/calendars/${calendarID}/events?key=${apiKey}&${queryStr}`
    );

    if (response.status === 200) {
      const data = await response.json();
      let events = data.items;
      if (events.length) setEvents(events);
      setLoading(false);
    } else {
      console.log(response.statusText);
      setLoading(false);
    }
  };

  return {
    events,
    loading,
  };
};

export default useGoogleCalendar;
